import Vue from 'vue'
import Router from 'vue-router'

import adminRouter from './routers/admin'
import writerRouter from './routers/writer'
import masterAdminRouter from './routers/masterAdmin'
import masterWriterRouter from './routers/masterWriter'
import masterClientRouter from './routers/masterClient'
import userAuthRouter from './routers/userAuth'

import NotFound from '/src/components/pages/errors/NotFound'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    adminRouter,
    writerRouter,
    masterAdminRouter,
    masterWriterRouter,
    masterClientRouter,
    userAuthRouter,
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const notFound = await store.dispatch('errorPage/checkNotFound')
  if (notFound) return

  const loggedIn = await store.dispatch('UserAuthStore/loggedIn')
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ path: '/user_auths/sign_in', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
